/** Окно номеров страниц с многоточиями: всегда первая/последняя/текущая ± соседи. */
export function pageWindow(current0: number, pageCount: number): (number | 'gap')[] {
    const current = current0 + 1; // 1-based
    const wanted = new Set<number>([1, pageCount, current, current - 1, current + 1]);
    const pages = [...wanted].filter((p) => p >= 1 && p <= pageCount).sort((a, b) => a - b);
    const out: (number | 'gap')[] = [];
    let prev = 0;
    for (const p of pages) {
        if (p - prev > 1) out.push('gap');
        out.push(p);
        prev = p;
    }
    return out;
}
